import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { RelativeTimeUnits } from 'pounceV2';

dayjs.extend(duration);

const getDurationUnit = (iso8601Duration: string): RelativeTimeUnits => {
  const isTimeDuration = iso8601Duration.startsWith('PT');
  const unit = iso8601Duration?.slice(-1);

  if (unit === 'M') {
    return isTimeDuration ? RelativeTimeUnits.Mins : RelativeTimeUnits.Months;
  }

  // find RelativeTimeUnits that starts with the unit
  return Object.values(RelativeTimeUnits).find(unitType => {
    return unitType.toLowerCase().startsWith(unit.toLowerCase());
  });
};

export const getIso8601DurationUnitAndValue = (
  iso8601Duration: string,
): [number, RelativeTimeUnits] => {
  const dayjsDurationObj = dayjs.duration(iso8601Duration);

  // Take the last character of the string to get the unit. durationUnit will be undefined if the
  // iso8601Duration is not a valid or supported duration (for example, we don't support seconds [s]
  // which is valid, but not supported)
  const durationUnit = getDurationUnit(iso8601Duration);

  // We need to handle mins since it should be minutes. We also need to capitalize the first letter
  const unitMethod = durationUnit
    ? `as${
        durationUnit === RelativeTimeUnits.Mins
          ? 'Minutes'
          : durationUnit.charAt(0).toUpperCase() + durationUnit.slice(1)
      }`
    : '';

  const durationValue = unitMethod ? dayjsDurationObj[unitMethod]() : 0;

  return [durationValue, durationUnit as RelativeTimeUnits];
};
